import React from "react";
import { useState } from 'react';
import { Message } from 'primereact/message'

interface Props {
    statusMessage: string | null;
    showStatus: boolean;
    isError: boolean;
}
function DatabaseManagementStatusMessage({ statusMessage, showStatus, isError }: Props) {
    return (
        <>
            {showStatus &&
                <div className="status-message-control">
                    <Message text={statusMessage} severity={isError === true ? "error" : "success"} ></Message>
                </div>
            }
                        
        </>
    );
}

export default DatabaseManagementStatusMessage;